import { render, staticRenderFns } from "./FormPendingSubModal.vue?vue&type=template&id=0a9ffd0a&scoped=true"
import script from "./FormPendingSubModal.vue?vue&type=script&lang=js"
export * from "./FormPendingSubModal.vue?vue&type=script&lang=js"
import style0 from "./FormPendingSubModal.vue?vue&type=style&index=0&id=0a9ffd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ffd0a",
  null
  
)

export default component.exports